import type { IRootData } from '@/types/organization'

const STATUS_ORDER = [
  'under_review',
  'planned',
  'in_progress',
  'completed',
  'closed',
]
export const cleanUserRootData = (data: IRootData) => {
  const sortedBuckets = (data.buckets || []).sort(
    (a, b) => a.position - b.position
  )

  const sortedCustomStates = (data.custom_states || []).sort((a, b) => {
    const aIndex = STATUS_ORDER.indexOf(a.status)
    const bIndex = STATUS_ORDER.indexOf(b.status)

    // If either status is not found in statusOrder, move it to the end
    if (aIndex === -1) return 1
    if (bIndex === -1) return -1

    return aIndex - bIndex
  })
  // .sort((b) => (b.default ? -1 : 1))

  return {
    ...data,
    buckets: sortedBuckets,
    custom_states: sortedCustomStates,
  }
}
